export const BRAND_MONITORING_COMPETITORS_REPORT_STATE = "brandmonitoring.competitors";

export const COMPETITORS_ENDPOINT = "api/brandMonitor/CompetitorReport/Table";
export const COMPETITOR_REPORT_TABLE_COLUMNS_PREFERENCES_KEY = "brandMonitorCompetitorTableColumns";
export const COLUMN_PICKER_MAX_HEIGHT = 448;
export const SORT_DEFAULT = "shareOfVoice";
export const SORT_DESC = "desc";
